import { render, staticRenderFns } from "./coinInfo.vue?vue&type=template&id=b72a9ee2&scoped=true"
import script from "./coinInfo.vue?vue&type=script&lang=ts"
export * from "./coinInfo.vue?vue&type=script&lang=ts"
import style0 from "./coinInfo.vue?vue&type=style&index=0&id=b72a9ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72a9ee2",
  null
  
)

export default component.exports